import { NoteAudioType } from '@models/note-audio-type.enum';

export class ServiceNoteAudio {
  id: number = 0;
  serviceNoteId: number = 0;
  noteAudioType: NoteAudioType;
  transcript: string;
  audioBlobUrl: string;
  createdDate: Date = new Date();
  createdById: string;
}
